// Import PGBA common plugin
import PgbaCommonPlugin from '../common/PgbaCommonPlugin';

import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

// Import component parsing utility
import ComponentParser from '../util/ComponentParser';

// Import bootstrap vue components
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

// Import custom vue components to use in profile management
import ProfileSelect from './components/ProfileSelect.vue';

// Import profile store and router factory methods
import {getStore} from './select-profile-resources';

// Register framework libraries
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(PgbaCommonPlugin);

// Create custom store and router from factory methods
const store = getStore();

ComponentParser.parse('pgba-select-profile', ProfileSelect, { store });
